export const CustomCategoryImage = require('./custom-category.webp');
